module.exports = "./img/desktop_logo.94a1ec5.png";